<div class="d-none">
  <input type='file' #fileInput id="FileInput" name="FileInput" [accept]="this.acceptFiles"
         [multiple]="false" (change)="onFileSelected($event)"/>
</div>

@if (this.file) {
  <span>{{ this.file.name }}</span>
  @if (format === 'button') {
    @if (isValidationButton) {
      <button type="button"
              class="btn btn-sm ps-2"
              (click)="onClickValidateFile()"
      ><i class="mdi mdi-check"></i></button>
      <button type="button"
              class="btn btn-sm ps-2"
              (click)="onClickClearSelectedFile()"><i class="mdi mdi-close"></i></button>
    } @else {
      @if (isClearButton) {
        <button type="button"
                class="btn btn-sm ps-2"
                (click)="onClickClearSelectedFile()"><i class="mdi mdi-close"></i></button>
      }
    }
  }
  @if (format === 'link') {
    @if (isValidationButton) {
      <a role="button"
         class="ps-2"
         (click)="onClickValidateFile()"
      ><i class="mdi mdi-check"></i></a>
      <a role="button"
         class="ps-2"
         (click)="onClickClearSelectedFile()"><i class="mdi mdi-close"></i></a>
    } @else {
      @if (isClearButton) {
        <a role="button"
           class="ps-2"
           (click)="onClickClearSelectedFile()"><i class="mdi mdi-close"></i></a>
      }
    }
  }
}

@if (format === 'button' && !this.file) {
  <button type="button"
          class="btn-sm btn btn-outline-primary"
          (click)="fileInput.click()"
          translate
  >DOCUMENT_LBL_NEWFILE
  </button>
}
@if (format === 'link' && !this.file) {
  <a role="button"
     (click)="fileInput.click()"
     translate
  >DOCUMENT_LBL_NEWFILE
  </a>
}
